import { render, staticRenderFns } from "./NoPiracyComponent.vue?vue&type=template&id=23da4160&scoped=true&"
import script from "./NoPiracyComponent.vue?vue&type=script&lang=ts&"
export * from "./NoPiracyComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NoPiracyComponent.vue?vue&type=style&index=0&id=23da4160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da4160",
  null
  
)

export default component.exports